import {z} from 'zod';
import {requestParamsValidator} from './requestParameter';
import {presNameValidator} from './name';
import {ProtectionType} from '../../presentationProtection';
import {gameConfigValidator} from './gameConfig';
import {MAX_PRESENTATION_DESCRIPTION_LENGTH} from './description';
import {protectionSchema} from '../presentationProtection/protectionSchema';

const retryQuestionSettingsValidator = z.object({
    retryQuestion: z.boolean().optional(),
    noOfAttempts: z.number().int().positive().optional(),
});

const presentationMetaSchema = z.object({
    _id: z.string(),
    gameConfig: gameConfigValidator,
    slideIndexList: z.array(z.string()),
    scrollButtonsOn: z.boolean().optional(),
    firstTimeUsing: z.boolean().nullable().optional(),
    toolbarColor: z.string().optional(),
    emptySpaceColor: z.string().optional(),
    presentationBackground: z.string().optional(),
    presentationMobileBackground: z.string().optional(),
    name: presNameValidator,
    description: z
        .string()
        .max(MAX_PRESENTATION_DESCRIPTION_LENGTH, `Description cannot exceed ${MAX_PRESENTATION_DESCRIPTION_LENGTH} characters`)
        .nullable()
        .optional(),
    created: z.string(),
    lastModified: z.string(),
    favorite: z.boolean().optional(),
    outerAreaColor: z.string().optional(),
    backgroundColor: z.string().nullable().optional(),
    presentationBackgroundName: z.string().optional(),
    presentationMobileBackgroundName: z.string().optional(),
    dataCollection: z.boolean().optional(),
    userEmail: z.string().email().optional(),
    userId: z.string().optional(),
    firstSlidePreview: z.string().optional(),
    protectionTypes: z.array(z.nativeEnum(ProtectionType)).optional(),
    requestParams: z.array(requestParamsValidator).optional(),
    presentationThemeId: z.string().optional(),
    isReadOnly: z.boolean().optional(),
    isShared: z.boolean().optional(),
    retryQuestionSettings: retryQuestionSettingsValidator.optional(),
    found: z.boolean().optional(),
});

export const presentationSettingsSchema = z.object({
    presentation: presentationMetaSchema,
    protection: protectionSchema,
});

export type PresentationSettingsFormType = z.infer<typeof presentationSettingsSchema>;
